import { Box, t } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { SkeletonVariant } from './enum';
import { SkeletonProps } from './types';

export const SkeletonWaveStyled = styled(Box).attrs({})<SkeletonProps>`
  ${({ width, height }) => css`
    width: ${width};
    height: ${height};
    ${getBackgroundColor}
    ${getBorderRadius}
    position: relative;
    overflow: hidden;
    &::after {
      animation: wave 1s linear 0.5s infinite;
      background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent);
      content: '';
      position: absolute;
      transform: translateX(-100%);
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
    }
    @keyframes wave {
      0% {
        transform: translateX(-100%);
      }
      50% {
        /* +0.5s of delay between each loop */
        transform: translateX(100%);
      }
      100% {
        transform: translateX(100%);
      }
    }
  `}
`;

export const SkeletonPulseStyled = styled(Box).attrs({})<SkeletonProps>`
  ${({ width, height }) => css`
    width: ${width};
    height: ${height};
    ${getBackgroundColor}
    ${getBorderRadius}
    animation: pulse 1s ease-in-out 0.5s infinite;
    @keyframes pulse {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0.4;
      }
      100% {
        opacity: 1;
      }
    }
  `}
`;

const getBackgroundColor = ({ backgroundColor }: SkeletonProps) => {
  if (backgroundColor) {
    return css`
      background-color: ${t(`colors.${backgroundColor}`)};
    `;
  }

  return null;
};

const getBorderRadius = ({ borderRadius, variant }: SkeletonProps) => {
  if (variant === SkeletonVariant.CIRCULAR) {
    return css`
      border-radius: ${({ theme }) => theme.radii[900]};
    `;
  } else if (borderRadius) {
    return css`
      border-radius: ${({ theme }) => theme.radii[borderRadius]};
    `;
  }

  return 0;
};
